// @flow

// Helpers
import { to } from '../../../lib/helpers';

// Requests
import { userGetTransactions as apiUserGetTransactions } from '../../../backend/userRequests';

// Consts
export const USER_TRANSACTIONS_GET = '[USER] GET TRANSACTIONS';
export const USER_TRANSACTIONS_SUCCESS = '[USER] TRANSACTIONS SUCCESS';
export const USER_TRANSACTIONS_ERROR = '[USER] TRANSACTIONS ERROR';

// Actions
export function userGetTransactions() {
  return {
    type: USER_TRANSACTIONS_GET,
  };
}
export function userTransactionsSuccess(transactions) {
  return {
    type: USER_TRANSACTIONS_SUCCESS,
    payload: transactions,
  };
}

export function userTransactionsError(err) {
  return {
    type: USER_TRANSACTIONS_ERROR,
    payload: err,
  };
}

// Thunks
export function fetchTransactions() {
  return async function getHistoryThunk(dispatch) {
    // Let the app know we are fetching transactions
    dispatch(userGetTransactions());

    // Dispatch api event to fetch transactions
    const [{ body }, err] = await to(dispatch(apiUserGetTransactions));

    // if there is an error, dispatch the error event
    if (err) {
      dispatch(userTransactionsError(err));
      return;
    }

    // Dispatch the success action
    dispatch(userTransactionsSuccess(body.data));
  };
}
